export default __webpack_public_path__ + "static/media/features-illustration.e877e6f5.png";